// src/layouts/trafficmonitoring/routeFlows/schemaDate.js


const routeFlowsDateSchema = [
  // Egnatia
  {
    id: 1,
    road: "egnatia",
    direction: "in",
    title: "Egnatia West",
    endPoint: "/rpc/get_route_flows_egnatia",
    valueKey: "value_in",
    typicalKey: "typical_value_in",
    sort: "asc",
  },
  {
    id: 2,
    road: "egnatia",
    direction: "out",
    title: "Egnatia East",
    endPoint: "/rpc/get_route_flows_egnatia",
    valueKey: "value_out",
    typicalKey: "typical_value_out",
    sort: "desc", 
  },

  // Olgas
  {
    id: 3,
    road: "olgas",
    direction: "in",
    title: "Olgas",
    endPoint: "/rpc/get_route_flows_olgas",
    valueKey: "value_in",
    typicalKey: "typical_value_in",
    sort: "asc",
  },

  // Nikis
  {
    id: 4,
    road: "nikis",
    direction: "out",
    title: "Nikis",
    endPoint: "/rpc/get_route_flows_nikis",
    valueKey: "value_out",
    typicalKey: "typical_value_out",
    sort: "asc",
  },
];

export default routeFlowsDateSchema;
